export enum ImageCategory {
  VACANCY = 'VacancyPhoto',
  CANDIDATE = 'CandidatePhoto',
}

// !NOTES: Used only server side because it depends on Otys session ID
export const constructImageUrl = ({
  ouid,
  sid,
  category,
}: {
  ouid: string
  sid: string
  category: ImageCategory
}) => {
  if (!ouid || !sid) return ''

  const baseUrl = process.env.JSON_RPC_FILE_DOWNLOAD_SERVICE_ENDPOINT
  const imgUrl = `${baseUrl}?sessionId=${sid}&ouid=${ouid}&class=${category}&mode=1`
  return imgUrl
}

export function getURLParamByName(name: string): string {
  if (typeof window === 'undefined') return ''

  const searchQuery = window.location.search
  const searchQueryParams = new URLSearchParams(searchQuery)
  const param = searchQueryParams.get(name)
  if (!param) throw new Error('Param name does not exist')

  return param
}
